import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formatMoney } from 'accounting';
import { ResponsiveBar } from '@nivo/bar';
import _ from 'lodash';

import Item from '../../../../models/Item';
import { getItemType } from '../../../../config/constants';
import { flatColors } from '../../../../config/chartColors';
import { getComparativeChartData } from '../../../../redux/selectors/collections';
import './ComparativeValueChart.css';

const ComparativeValueChart = ({ data, item, tooltipTextFn }) => {
  const dataKeys = data.map(d => _.keys(d).find(k => k.includes('AvgMarketValue')));
  const dataMaxes = dataKeys.map((dk, index) => data[index][dk]);
  const maxValue = Math.max(item.itemData.market_value, _.max(dataMaxes)) * 1.1;

  return (
    <div style={{ height: '24rem' }}>
      <ResponsiveBar
        data={data}
        indexBy="category"
        keys={dataKeys}
        maxValue={maxValue}
        markers={[
          {
            axis: 'y',
            value: item.itemData.market_value,
            lineStyle: { stroke: 'rgba(0, 0, 0, 0.5)', strokeWidth: 2, strokeDasharray: '3,3' },
            legend: `This ${getItemType(item.category)}: ${formatMoney(
              item.itemData.market_value,
              '$',
              0
            )}`,
          },
        ]}
        enableLabel={false}
        colors={flatColors}
        padding={0.1}
        margin={{
          top: 10,
          right: 10,
          bottom: 100,
          left: 60,
        }}
        axisLeft={{
          format: v => formatMoney(v, '$', 0),
        }}
        axisBottom={{
          tickRotation: -45,
          tickSize: 0,
          legendOffset: 60,
        }}
        tooltip={tooltipTextFn}
        theme={{
          tooltip: {
            container: {
              background: '#efefef',
            },
          },
        }}
      />
    </div>
  );
};

ComparativeValueChart.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.array.isRequired,
  item: PropTypes.instanceOf(Item).isRequired,
  tooltipTextFn: PropTypes.func,
};

ComparativeValueChart.defaultProps = {
  tooltipTextFn: v => v.value,
};

function mapStateToProps(state) {
  const comparativeData = getComparativeChartData(state);

  return {
    data: comparativeData,
  };
}

export default connect(mapStateToProps)(ComparativeValueChart);



// WEBPACK FOOTER //
// ./src/components/pages/collections/items/ComparativeValueChart.jsx